import React, { useEffect } from 'react';
import Hometopimage from '../../assets/images/civiltop.jpeg';

import villa1 from '../../assets/images/civil/top-1.webp';
import villa2 from '../../assets/images/vilaimage2.jpg';
import villa3 from '../../assets/images/civil/top-2.jpg';
import civilapproach from '../../assets/images/civilapproach.jpg';
import warehouse from '../../assets/images/warehouse.webp';
import substation from '../../assets/images/substation.jpg';
import luxury from '../../assets/images/civil/su.jpg';
import { Link } from "react-router-dom";

//aos animation
import AOS from 'aos';
import 'aos/dist/aos.css';



// REACT ICONS
import { MdElectricBolt } from "react-icons/md";
import { GoProjectRoadmap } from "react-icons/go";
import { FaEye } from "react-icons/fa";
import { AiOutlineSetting } from "react-icons/ai";
import { FaLightbulb } from "react-icons/fa";
import { MdHighQuality } from "react-icons/md";
import { CgProfile } from "react-icons/cg";
import { TiMediaFastForward } from "react-icons/ti";
import { FaBusinessTime } from "react-icons/fa";
import Testimonial from '../../components/Testimonials/Testimonial';
import Metatag from '../../components/Metatag/Metatag';
const Civil = () => {
    useEffect(() => {
        // Scroll to the top when the page loads
        window.scrollTo(0, 0);
      }, []);
    
    useEffect(() => {
        AOS.init({
          once:true,
        });
      }, []);
    const civilVillas = [
        {
            heading: "Substation Mastery",
            subheading: "Fueling Advancement: Pioneering Substation Construction for the Future.",
            text: "At Megavolt Contracting LLC, we specialize in the complex field of substation maintenance services, striving for advanced performance rather than just functionality. Our experts create substation solutions that exceed industry standards by utilizing the latest technologies and best practices.",
            img: substation,
        },
        {
            heading: "Luxury Villa Development",
            subheading: "Creating Exclusivity: Villas for Outstanding Living.",
            text: "Our expertise lies in crafting unique residences that combine exquisite craftsmanship with sophisticated architecture. With a focus on luxury, our carefully selected components meet or exceed the highest standards, establishing a foundation for success as a reliable villa fit-out contractor in Dubai.",
            img: luxury,
        },
        {
            heading: "Warehouse Excellence",
            subheading: "Foundations for Success: Distinctive Warehouse Services.",
            text: "Our exclusive warehousing solutions lay the groundwork for efficient operations and seamless logistics. In Dubai's bustling commerce landscape, we strategically design storage solutions that align with your unique needs, ensuring your business runs smoothly.",
            img: warehouse,
        }
    ];

    const ourApproach = [
        {
            icon: FaEye,
            heading: "Initial Consultation: Understanding Your Vision",
            text: "Our initial consultation is a crucial stage where we fully immerse ourselves in comprehending your vision, which is at the core of our service."
        },
        {
            icon: MdElectricBolt,
            heading: "Sustainable Practices",
            text: "We are committed to sustainability, integrating eco-friendly materials and practices into our projects. Our focus on reducing environmental impact ensures that we not only meet current standards but also contribute positively to future generations."
        },
        {
            icon: FaLightbulb,
            heading: "Customized Planning and Design",
            text: "Our commitment to excellence is reflected in specialized planning and adaptable design, ensuring precision and alignment with your project's requirements."
        },
        {
            icon: GoProjectRoadmap,
            heading: "Transparent Project Costing",
            text: "We ensure clarity and budget integrity through transparent project costing, providing a clear breakdown for informed decision-making."
        },
        {
            icon: AiOutlineSetting,
            heading: "Efficient Project Management",
            text: "Our results-driven approach relies on efficient project management, facilitating smooth collaboration, timely delivery, and optimal resource utilization."
        },
        {
            icon: MdHighQuality,
            heading: "Quality Construction",
            text: "Our dedication to excellence is rooted in high-quality construction, emphasizing accuracy, durability, and adherence to rigorous industry standards."
        },
        {
            icon: CgProfile,
            heading: "Continuous Client Engagement",
            text: "We prioritize ongoing client interaction, fostering essential partnerships throughout the project with open communication, active teamwork, and real-time feedback."
        },
        {
            icon: FaBusinessTime,
            heading: "On-Time Delivery",
            text: "Our committed team ensures timely delivery through meticulous planning and execution, meeting all project deadlines."
        },
        {
            icon: TiMediaFastForward,
            heading: "Post-Construction Support",
            text: "We take great pride in providing thorough post-construction support, demonstrating our commitment to ensuring client satisfaction long after project completion."
        },

    ];

    return (

        <>
        <Metatag title="Civil Engineering Services | Expert Solutions for Construction & Infrastrtsture Projects" description=" Discover professional civil engineering services for construction, infrastructure development, and project management. Our experienced team delivers costeffective, high-quality solutions for residential,commercial, and industrial projects" link="civil"/>
            <div className=' relative bg-cover bg-no-repeat bg-center w-full h-full overflow-hidden' style={{ backgroundImage: `url(${Hometopimage})`, backgroundRepeat: 'no-repeat' }}>
                <div className=' absolute inset-0 bg-black  opacity-45'></div>
                <div className='  relative  p-3 py-10 sm:py-24 sm:pl-7' data-aos="fade-left" data-aos-duration="2500" data-aos-delay="200">

                    <h1 className=' mt-1  text-orange font-bold text-[24px] sm:text-5xl'>Building Contractors in Dubai</h1>
                    <p className='  text-xl sm:pt-5 text-white'>Professional Civil Contracting in Dubai, Tailored Solutions for Every Need.</p>
                    <Link to='/contactus'>
                    <button className=' bg-[#feb231] rounded-xl px-3 py-2 mt-2 sm:mt-5 text-[#000000] font-semibold hover:shadow-[1px_4px_1px_0px_rgba(0,0,1)]' >
                        Stay Connect
                    </button>
                    </Link>
                
                </div>
            </div>

            <div className='bg-[white] overflow-hidden'>
                <div className='p-3 lg:p-1 sm:pt-7 container'>
                    <h1 className="sm:mb-4 mb-2 text-xl pt-1 sm:pt-6 font-bold uppercase text-center md:text-4xl">
                        Meeting Your Diverse Needs
                    </h1>
                    <p className="text-sm md:text-base text-[#7a7a7a]  container text-justify sm:text-center leading-6">
                        We recognize the significance of innovation and professionalism in civil contracting. Our team comprises the finest professionals, dedicated to delivering exceptional results that meet your unique project requirements.
                    </p>
                    <div className='grid grid-flow-row grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 mt-6 sm:mt-12  sm:pb-6 overflow-hidden'>
                       
                        <div className=' overflow-hidden rounded-xl' data-aos="zoom-in" data-aos-duration="1000" data-aos-delay="300" data-aos-offset="1">
                            <img src={villa2} className='w-full h-48 sm:h-56 lg:h-64 object-cover rounded-xl hover:scale-[1.05] ease-linear transition-transform duration-200' alt='Villa Development' />
                            <p className="text-sm md:text-base text-[#7a7a7a]  pt-3 font-semibold text-center leading-6">Villa Development</p>
                        </div>
                        <div className=' overflow-hidden rounded-xl' data-aos="zoom-in" data-aos-duration="1000" data-aos-delay="500" data-aos-offset="1">
                            <img src={villa3} className='w-full h-48 sm:h-56 lg:h-64 object-cover rounded-xl hover:scale-[1.05] ease-linear transition-transform duration-200' alt='Substation' />
                            <p className="text-sm md:text-base text-[#7a7a7a]  pt-3 font-semibold    text-center leading-6">Warehouse</p>
                        </div>
                        <div className=' overflow-hidden rounded-xl ' data-aos="zoom-in" data-aos-duration="1000" data-aos-delay="100"  data-aos-offset="1">
                            <img src={villa1} className='w-full h-48 sm:h-56 lg:h-64 object-cover rounded-xl hover:scale-[1.05] ease-linear transition-transform duration-200' alt='Substation' />
                            <p className="text-sm md:text-base text-[#7a7a7a] text-center pt-3 font-semibold leading-6">Substation</p>
                        </div>
                    </div>
                </div>
            </div>

            <div className=' sm:mt-6 container p-3 lg:p-0'>
                <h1 className="mb-4 text-2xl font-bold  text-center md:text-4xl"> Why Partner with Us?</h1>
                <div className=' grid  grid-cols-12 gap-4 mt-2 sm:mt-9  lg:p-0'>
                    <div className=' col-span-12 sm:col-span-7 sm:p-4'>
                        <h1 className=' pt-1 sm:pt-2 text-orange text-2xl font-semibold'> Our Value to Your Vision</h1>
                        <p className="text-sm md:text-base text-[#7a7a7a]  pt-3 font-semibold  text-justify leading-6">Entering into a partnership with us in the dynamic realm of construction servicess ensures not just collaboration, but a transformative journey in knowledge, creativity, and an unwavering commitment to quality. Backed by extensive experience and a deep understanding of the complexities involved in villa development, our expert team is equipped to provide a range of tailored solutions that align perfectly with your specific needs.</p>
                        <div className=' flex items-center pt-4 group w-max '>
                            <MdElectricBolt className='text-[#feb231] group-hover:text-black ' /> <p className=' pl-2 group-hover:text-[#feb231] text-black '>Tailored Solutions</p>
                        </div>

                        <div className=' flex items-center pt-4 group w-max '>
                            <MdElectricBolt className='text-[#feb231] group-hover:text-black ' /> <p className=' pl-2 group-hover:text-[#feb231] text-black '>Expert Guidance</p>
                        </div>
                        <div className=' flex items-center pt-4 group w-max '>
                            <MdElectricBolt className='text-[#feb231] group-hover:text-black ' /> <p className=' pl-2 group-hover:text-[#feb231] text-black '>Sustainable Practices</p>
                        </div>
                    </div>
                    <div className=' col-span-12 sm:col-span-5 '>
                        <img src={civilapproach} className=' w-full h-full object-cover' />
                    </div>
                </div>
            </div>
            <div className=' container mt-3 sm:mt-10 p-3 lg:p-0'>
                <h1 className="sm:mb-4 text-2xl sm:pt-6 font-bold  text-center md:text-4xl">
                    Our Approach
                </h1>
                <p className="text-sm md:text-base text-[#7a7a7a]  pt-3 font-semibold  sm:mt-6  text-justify  sm:text-center leading-6">From the beginning, our approach emphasizes collaboration and flexibility, fully complying with the standards established by Dubai municipality and DEWA. We are committed to delivering innovative, high-quality, and customer-centric solutions. Our unique methodology prioritizes a deep understanding of our clients' specific needs, allowing us to execute each project with keen insight into their individual goals and aspirations.</p>
                <div className='grid grid-flow-row grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 sm:gap-6 mt-10'>
                    {ourApproach.map((item, index) => (
                        <div
                            key={index}
                            
                            className='border-2 border-[#ccc] p-8 rounded-3xl bg-black ease-linear  duration-150 group hover:bg-[#f7b12d] hover:transform transition-all'
                        >
                            <div className='flex items-center'>
                                <div className='bg-black  rounded-full mt-3 ease-linear duration-300 group hover:bg-[#f7b12d] transition-all'>
                                    <item.icon className=' text-orange group-hover:text-white font-semibold text-6xl p-2 ease-linear duration-300 transition-all' />
                                </div>
                                <p className='pl-2 text-[#f7b12d] font-semibold text-xl group-hover:text-black'>{item.heading}</p>
                            </div>


                            <p className='text-white group-hover:text-black mt-2'>{item.text}</p>
                        </div>
                    ))}
                </div>
            </div>
            <div className='mt-0 sm:mt-16 mb-6 container p-3 lg:p-0'>
                {civilVillas.map((item, index) => (
                    <div key={index}>
                        <div
                            className={`flex flex-col sm:flex-row gap-2 sm:gap-6 mt-4 sm:mt-8 ${index % 2 === 0 ? '' : 'sm:flex-row-reverse'
                                }`}
                        >
                            <div className='flex-1'>
                                <div className='bg-black h-full'>
                                    <img src={item.img} className='w-full h-full object-cover  lg:h-96' alt={item.heading} />
                                </div>
                            </div>
                            <div className='flex-1 flex flex-col justify-center'>
                                <p className=" mb-1 sm:mb-4 text-2xl sm:pt-6 pt-1 font-bold  text-center md:text-4xl"> {item.heading}</p>
                                <p className='pt-2 sm:pt-3 text-[#f7b12d] text-center font-semibold text-[19px] sm:text-xl'>{item.subheading}</p>
                                <p className="text-sm md:text-base text-[#7a7a7a]  pt-3 font-semibold  sm:text-justify    leading-6">{item.text}</p>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
           <Testimonial/>

        </>

    )
}

export default Civil    
